class RedeemMouthpiece extends HTMLElement {
  constructor() {
    super();
    this.currentStep = 0;
    this.steps = [];
    this.stepsImage = [];
    this.selectedOptionId = "";
    this.googleMapsLoaded = false;
    this.selectedPlace = false;
    this.addressData = {};
  }

  connectedCallback() {
    this.steps = Array.from(this.querySelectorAll(".step-content"));
    this.stepsImage = Array.from(this.querySelectorAll(".step-image"));
    this.productId = this.querySelector("form").dataset.productId;
    this.customerNameContent = this.querySelector("#customerName");
    this.customerEmailContent = this.querySelector("#customerEmail");
    this.mainTitleFinalResponse = this.querySelector("#mainTitleFinalResponse");

    this.loadGoogleMapsScript();

    const draftOrderData = sessionStorage.getItem("draftOrder");
    if (draftOrderData) {
      this.sessionStorageDataVerify();
      this.currentStep = 2;
      this.updateProgressBar();
    }

    this.steps.forEach((step) => {
      const form = step.querySelector("form");
      if (form) {
        form.addEventListener("submit", (event) =>
          this.handleFormSubmit(event)
        );
      }
    });

    this.querySelectorAll("[data-selectable-option-membership]").forEach(
      (option) => {
        option.addEventListener("click", (event) =>
          this.handleOptionSelection(event)
        );
      }
    );

    this.addEventListener("click", (event) => {
      const target = event.target.closest("button");
      if (!target) return;
      if (target.classList.contains("next-button")) this.nextStep();
      if (target.classList.contains("back-button")) this.previousStep();
    });

    const phoneInput = this.querySelector("#phone-number");
    phoneInput.addEventListener("input", (e) => this.formatPhoneNumber(e));

    const select = this.querySelector("select");
    if (select) {
      select.addEventListener("change", (event) => {
        const selectedOption = select.options[select.selectedIndex];
        const listId = selectedOption.getAttribute("data-list-id");
        const form = event.target.closest("form");
        if (form && listId) {
          form.setAttribute("data-list-id", listId);
        }
      });
    }

    this.updateStepVisibility();
  }

  loadGoogleMapsScript() {
    if (window.google?.maps) {
      this.initAutocomplete();
      return;
    }

    const script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyBfA30hm-UkQVj_VvPhUzLWt_6wTl1r2lc&libraries=places";
    script.async = true;
    script.defer = true;
    script.onload = () => this.initAutocomplete();
    document.head.appendChild(script);
  }

  initAutocomplete() {
    const input = this.querySelector("#shipping-address");
    if (!input) return;

    const autocomplete = new google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: "us" },
      types: ["address"],
    });

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (!place.address_components) {
        this.selectedPlace = false;
        return;
      }

      this.selectedPlace = true;

      const get = (type) =>
        place.address_components.find((c) => c.types.includes(type))
          ?.long_name || "";
      const getShort = (type) =>
        place.address_components.find((c) => c.types.includes(type))
          ?.short_name || "";

      this.addressData = {
        address: `${get("street_number")} ${get("route")}`.trim(),
        city:
          get("locality") ||
          get("sublocality") ||
          get("administrative_area_level_2"),
        zip: get("postal_code"),
        state: getShort("administrative_area_level_1"),
        country: getShort("country"),
      };
    });

    input.addEventListener("blur", () => {
      if (!this.selectedPlace) {
        input.value = "";
        this.addressData = null;
      }
    });
  }

  sessionStorageDataVerify() {
    this.draftOrderData = sessionStorage.getItem("draftOrder");
    this.formDataSS = sessionStorage.getItem("formData");
    const draftOrder = JSON.parse(this.draftOrderData);
    if (this.draftOrderData && !draftOrder.error) {
      this.successCreateOrderResponse(this.draftOrderData, this.formDataSS);
    }
  }

  successCreateOrderResponse(draftOrderData, formDataSS) {
    const draftOrder = JSON.parse(draftOrderData);
    const formData = JSON.parse(formDataSS);
    this.updateProgressBar();
    this.customerNameContent.textContent = `${formData["first-name"]} ${formData["last-name"]}`;
    this.customerEmailContent.textContent = draftOrder?.customer?.email;
    this.querySelector("copy-text").setAttribute(
      "full-text",
      draftOrder?.order?.id.replace("gid://shopify/Order/", "")
    );
  }

  updateStepVisibility() {
    this.steps.forEach((stepEl, index) => {
      stepEl.classList.toggle("hidden", index !== this.currentStep);
    });
    this.stepsImage.forEach((imgEl, index) => {
      imgEl.classList.toggle("hidden", index !== this.currentStep);
    });
  }

  updateProgressBar() {
    const stepName = this.querySelector("#step-name");
    const stepIndex = this.querySelector("#step-index");
    const progressBar = this.querySelector("#progress-bar div");

    if (stepName) stepName.textContent = this.steps[this.currentStep]?.id || "";
    if (stepIndex) stepIndex.textContent = `Step: ${this.currentStep + 1}`;
    if (progressBar) {
      const percent = ((this.currentStep + 1) / this.steps.length) * 100;
      progressBar.style.width = `${percent}%`;
    }
  }

  nextStep() {
    if (this.currentStep < this.steps.length - 1) {
      this.currentStep++;
      this.updateStepVisibility();
      this.updateProgressBar();
    }
  }

  previousStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
      this.updateStepVisibility();
      this.updateProgressBar();
    }
  }

  formatPhoneNumber(e) {
    let value = e.target.value.replace(/\D/g, "").slice(0, 10);
    const formatted = value.replace(
      /(\d{3})(\d{0,3})(\d{0,4})/,
      (m, p1, p2, p3) =>
        p3 ? `(${p1}) ${p2}-${p3}` : p2 ? `(${p1}) ${p2}` : `(${p1}`
    );
    e.target.value = formatted;
  }

  isValidUSPhone(phone) {
    const digits = phone.replace(/\D/g, "");
    return (
      digits.length === 10 || (digits.length === 11 && digits.startsWith("1"))
    );
  }

  isValidUSPhoneNumber(phone) {
    return this.isValidUSPhone(phone);
  }

  async handleFormSubmit(event) {
    event.preventDefault();

    const form = event.target;
    const submitBtn = form.querySelector(".send-form-button-js");
    const errorBox = form.querySelector(".form-error-box");
    const errorList = errorBox.querySelector("ul");

    submitBtn.disabled = true;
    submitBtn.textContent = "Processing...";

    errorList.innerHTML = "";
    errorBox.classList.add("hidden");

    const requiredInputs = Array.from(
      form.querySelectorAll(
        "input[required], select[required], textarea[required]"
      )
    );

    const missingFields = [];

    requiredInputs.forEach((input) => {
      const value =
        input.type === "checkbox" ? input.checked : input.value.trim();
      if (!value) {
        const label = form.querySelector(`label[for="${input.id}"]`);
        const name = label
          ? label.textContent.replace("*", "").trim()
          : input.name;
        missingFields.push(name);
      }
    });

    if (missingFields.length > 0) {
      missingFields.forEach((field) => {
        const li = document.createElement("li");
        li.textContent = field;
        errorList.appendChild(li);
      });
      errorBox.classList.remove("hidden");
      form.scrollIntoView({ behavior: "smooth" });
      submitBtn.disabled = false;
      submitBtn.textContent = "Submit";
      return;
    }

    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());
    data.address = this.addressData;

    const firstName = data["first-name"].trim();
    const lastName = data["last-name"].trim();
    const email = data.email;
    const phone = data["phone-number"];

    this.email = email;
    this.phone = phone;

    sessionStorage.setItem("formData", JSON.stringify(data));

    try {
      const draftOrderResponse = await this.draftOrder(data);
      if (!draftOrderResponse.error) {
        await this.sendToKlaviyo({
          first_name: firstName,
          last_name: lastName,
        });
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = "Submit";
      this.sessionStorageDataVerify();
    }
  }

  async draftOrder(customer) {
    const url =
      "https://feno-co-tjjv.vercel.app/api/redeem-mouthpiece-flow";
    const complementAddress = this.querySelector(
      "#shipping-address-complement"
    );
    const phoneNumber = this.querySelector("#phone-number");

    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        firstName: customer["first-name"],
        lastName: customer["last-name"],
        email: customer.email,
        variantId: this.productId,
        phoneNumber: phoneNumber.value,
        address1: customer.address?.address,
        addressComplement: complementAddress.value,
        city: customer.address?.city,
        state: customer.address?.state,
        zip: customer.address?.zip,
        country: customer.address?.country,
      }),
    });

    const data = await response.json();

    if (data?.error) {
      this.sessionStorageDataVerify();
      this.showToast(data.error);
    } else {
      this.nextStep();
      this.sessionStorageDataVerify();
      sessionStorage.setItem("draftOrder", JSON.stringify(data));
    }

    return data;
  }

  async sendToKlaviyo(attributes) {
    const listId = this.querySelector("form").dataset.listId;
    const payload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: this.email,
                ...(this.phone ? { phone_number: `+1${this.phone}` } : {}),
                ...attributes,
                subscriptions: {
                  email: { marketing: { consent: "SUBSCRIBED" } },
                  ...(this.phone && {
                    sms: {
                      marketing: { consent: "SUBSCRIBED" },
                      transactional: { consent: "SUBSCRIBED" },
                    },
                  }),
                },
              },
            },
          },
        },
        ...(listId && {
          relationships: { list: { data: { type: "list", id: listId } } },
        }),
      },
    };

    const response = await fetch(
      "https://a.klaviyo.com/client/subscriptions/?company_id=YtTm4E",
      {
        method: "POST",
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
          revision: "2025-01-15",
        },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      try {
        const errorData = await response.json();
        throw new Error(
          errorData.errors?.[0]?.detail || "Klaviyo subscription request failed"
        );
      } catch {
        throw new Error("Klaviyo subscription request failed");
      }
    }
  }

  showToast(message, duration = 3000) {
    const toast = this.querySelector("#toast");
    toast.textContent = message;
    toast.classList.remove("opacity-0", "pointer-events-none");
    toast.classList.add("opacity-100");
    setTimeout(() => {
      toast.classList.remove("opacity-100");
      toast.classList.add("opacity-0", "pointer-events-none");
    }, duration);
  }

  handleOptionSelection(event) {
    const selected = event.currentTarget;
    const parent = selected.closest(".step-content");

    parent
      .querySelectorAll("[data-selectable-option-membership]")
      .forEach((opt) => {
        opt.className =
          "bg-[#F5F5F5] bg-opacity-50 rounded-lg p-5 cursor-pointer";
      });

    selected.className =
      "border border-blue rounded-2xl p-5 bg-[#F5F5F5] bg-opacity-50 cursor-pointer";
    this.selectedOptionId = selected.id;
  }
}

customElements.define("redeem-mouthpiece", RedeemMouthpiece);

/*
Copy Text
*/

class CopyText extends HTMLElement {
  static get observedAttributes() {
    return ["full-text"];
  }

  constructor() {
    super();
    this.copyButton = null;
    this.shortTextEl = null;
    this.fullText = "";
  }

  connectedCallback() {
    this.copyButton = this.querySelector(".copy-button");
    this.shortTextEl = this.querySelector(".short-text");
    this.fullText = this.getAttribute("full-text") || "";

    this.updateShortText();

    this.copyButton?.addEventListener("click", () => {
      navigator.clipboard
        .writeText(this.fullText)
        .then(() => {
          this.shortTextEl.textContent = "Copied!";
          setTimeout(() => this.updateShortText(), 2000);
        })
        .catch((err) => {
          console.error("Failed to copy:", err);
        });
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "full-text" && oldValue !== newValue) {
      this.fullText = newValue;
      this.updateShortText();
    }
  }

  updateShortText() {
    if (this.shortTextEl) {
      const shortText = `...${this.fullText.slice(-8)}`;
      this.shortTextEl.textContent = shortText;
    }
  }
}

customElements.define("copy-text", CopyText);
